<div class="modal fade" [class.show]="isShown">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{npd.title}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cancelar()">
			        <span aria-hidden="true"><i class="fa fa-times iconClose"></i></span>
		        </button>
            </div>
            <div class="modal-body">
                <p style="line-height: initial">{{npd.message}}</p>
                <div id="nombreProyecto">
                    <div class="input-group-prepend nombreProyecto">
                        <div class="input-group-text" id="btnGroupAddon">{{modelService.getString('win_new_project_nameProject')}}</div>
                    </div>
                    <input type="text" class="form-control" aria-describedby="btnGroupAddon" [(ngModel)]="npd.nombre">
                </div>
            </div>
            <div class="modal-footer">
                <button *ngIf="!(tipoProyecto===2)" type="button" class="btn botonSatelite" [disabled]="disabled()" (click)="nuevoSatelite()">
                    <i class="fa fa-globe" aria-hidden="true"></i>{{modelService.getString('win_new_project_sateliteView')}}
                </button>
                <button *ngIf="!(tipoProyecto===1)" type="button" class="btn botonMapa" [disabled]="disabled()" (click)="nuevoMapa()">
                    <i class="fa fa-map-o" aria-hidden="true"></i>{{modelService.getString('win_new_project_schema')}}
                </button>
            </div>
        </div>
    </div>
</div>